import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { findWidgetForGridSlot } from '../dashboard-layouts.utils';
import layoutStyles from '../utils/dashboard-layouts.styles';

const useStyles = makeStyles({
  ...layoutStyles
});

const LayoutM = props => {
  const classes = useStyles();
  const { singleColumnWidth } = props;

  const calculateWidgetForSlot = useCallback(slot => findWidgetForGridSlot({ ...props, slot }), [
    props
  ]);

  return (
    <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={1}>
      <Grid item xs={12} md={singleColumnWidth} className={classes.layoutMStyle}>
        {calculateWidgetForSlot(0)}
      </Grid>
      <Grid item xs={12} md={singleColumnWidth} className={classes.layoutMStyle}>
        {calculateWidgetForSlot(1)}
      </Grid>
    </Grid>
  );
};

LayoutM.propTypes = {
  singleColumnWidth: PropTypes.number
};

LayoutM.defaultProps = {
  singleColumnWidth: 12
};

export default LayoutM;
